import React from 'react'

function Resume() {
    return (
        <div className="col-md-6 col-sm-12">
        <h2 className="p-4">Resume</h2>

       <a href="./assets/images/LTownsend-2023.pdf" target="_blank"> <img src="assets/images/LTownsend.jpg" alt="resume" class="resume mb-5" /> </a>
      </div>
    )
};

export default Resume;
